
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { appApiResources } from '../../../configuration/app.constants';

@Injectable({
  providedIn: 'root'
})
export class UpdateEventStatusService {

  constructor(private http: HttpClient) { }

  async updateEventStatus(data) {
    try {
      const httpOptions = {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "description": "application/json",
          "type": "text",
          "enabled": "true"
        })
      };
      let response = await this.http
        // .post(`${appApiResources.updateEventStatus}`, data, httpOptions)
        .post("http://office.ezekiahfrancis.in/updateeventreg", data, httpOptions)
        .toPromise();
      return response;
    } catch (error) {
      return error;
    }
  }

  async eventRegisterByTeam(data) {
    try {
      const httpOptions = {
        headers: new HttpHeaders({
          "Content-Type": "application/json"
        })
      };
      let response = await this.http
        .post(`http://office.ezekiahfrancis.in/eventreg`, data, httpOptions)
        .toPromise();
      return response;

    } catch (error) {
      return error;
    }
  }

  async updateRoomStatus(data) {
    try {
      const httpOptions = {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "description": "application/json",
          "type": "text",
          "enabled": "true"
        })
      };
      let response = await this.http
        // .post(`${appApiResources.updateEventStatus}`, data, httpOptions)
        .post("http://office.ezekiahfrancis.in/approve_room", data, httpOptions)
        .toPromise();
      return response;
    } catch (error) {
      return error;
    }
  }

}